import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Heart } from "lucide-react";

export default function DateIdeas() {
  const [ideas, setIdeas] = useState([]);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/date-ideas"); setIdeas(data.ideas || []); }
      catch (e) { setErr(formatApiError(e)); }
    })();
  }, []);

  return (
    <div className="space-y-8">
      <div>
        <div className="text-xs uppercase tracking-widest text-rose">First date ideas</div>
        <h1 className="font-display text-5xl text-navy leading-tight">Meaningful, not memorable-for-the-wrong-reasons.</h1>
        <p className="text-navy/70 mt-2 max-w-2xl">A better prompt than "drinks?" — dates that let you actually see each other.</p>
      </div>
      <div className="grid md:grid-cols-3 gap-5">
        {ideas.map((it, i) => (
          <div key={i} className="glass rounded-3xl p-7" data-testid={`idea-${i}`}>
            <Heart size={22} className="text-rose" />
            <div className="mt-3 font-display text-2xl text-navy">{it.title}</div>
            <div className="text-sm text-navy/70 mt-2">{it.why}</div>
          </div>
        ))}
      </div>
      {err && <div className="text-sm text-rose-600">{err}</div>}
    </div>
  );
}
